import type { PitchUsageType } from "@/lib/pitchUsageType";

export type OccupancySettings = {
  dashboard_usage_types: PitchUsageType[];
};

export const DEFAULT_OCCUPANCY_SETTINGS: OccupancySettings = {
  dashboard_usage_types: ["tourism"],
};

export function parseOccupancySettings(
  raw: { dashboard_usage_types?: string[] } | null | undefined,
): OccupancySettings {
  const allowed = new Set<PitchUsageType>(["tourism", "permanent", "storage"]);
  const types = (raw?.dashboard_usage_types ?? DEFAULT_OCCUPANCY_SETTINGS.dashboard_usage_types)
    .filter((value): value is PitchUsageType => allowed.has(value as PitchUsageType));
  if (types.length === 0) {
    return DEFAULT_OCCUPANCY_SETTINGS;
  }
  return { dashboard_usage_types: [...new Set(types)] };
}

export function pitchEligibleForDashboardOccupancy(
  pitch: { usage_type?: string | null; is_active: boolean; is_blocked: boolean },
  usageTypes: readonly PitchUsageType[],
): boolean {
  const usage = (pitch.usage_type ?? "tourism") as PitchUsageType;
  return pitch.is_active && !pitch.is_blocked && usageTypes.includes(usage);
}

export function eligibleDashboardPitchIds(
  pitches: { id: string; usage_type?: string | null; is_active: boolean; is_blocked: boolean }[],
  usageTypes: readonly PitchUsageType[],
): Set<string> {
  const ids = new Set<string>();
  for (const pitch of pitches) {
    if (pitchEligibleForDashboardOccupancy(pitch, usageTypes)) {
      ids.add(pitch.id);
    }
  }
  return ids;
}
